
function parseData(data) {
    if((!data) || data.length==0){
        return null;
      }
      else {
        return JSON.stringify(data);
      }
}

function serviceFactory({ api }) {
  const getRecentSearch = ({ noOfRows, metaData }) =>
    api.getRecentSearchData(noOfRows, metaData)
      .then(parseData)
      .catch(() => null);

    const getPortfolioOrPositionData = ({ searchText, metaData }) =>
    api.getPortfolioOrPositionData(searchText, metaData)
    .then(parseData)
    .catch(() => null);

    const saveSearch = ({requestBody, metaData }) =>
    api.saveSearch(requestBody, metaData)
    .then(parseData)
    .catch(() => null);

  return {
    getRecentSearch,
    getPortfolioOrPositionData,
    saveSearch
  };
}

module.exports = serviceFactory;
